const title = "Team Banner Design Tool – Create & Customize Online";
export {title};